import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { CheckLg, ExclamationTriangle, EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { getManageSendingStaffList, getServiceStatusList, sendStaff } from "../store/api/Services";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker2";
import { useEffect, useRef, useState } from "react";
import { faBroom, faShareSquare, faTimes } from "@fortawesome/free-solid-svg-icons";
import { exportToExcel, keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";

const ManageSendingStaffList = () => {
    const dispatch = useDispatch();
    const frmFilters = useRef();
    const dateFilters = useRef({});
    const inputSendDate = useRef();
    const { register, handleSubmit } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const [sendingInfo, setSendingInfo] = useState({});
    const [submitError, setSubmitError] = useState(null);
    const [popSelectStaff, setPopSelectStaff] = useState({ show: false });
    const selectedServices = useRef([]);
    const settingNames = ['ProductGrouppingType'];
    const { filterData, serviceStatusList, systemSettings } = useSelector(state => {
        return {
            filterData: state.service.manageSendingStaffFilters,
            serviceStatusList: state.service.serviceStatusList,
            systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const pgType = Array.isArray(systemSettings ?? "") && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function onSelectRow(row) {
        const checked = row.e.target.checked;
        //const found = selectedServices.current.find(s=> Number(s.ServiceID) === Number(row.ServiceID) && s.ServiceType.toLowerCase() === row.ServiceType.toLowerCase());
        if (!checked) {
            selectedServices.current = selectedServices.current.filter(s => Number(s.ServiceID) !== Number(row.ServiceID) || s.ServiceType.toLowerCase() !== row.ServiceType.toLowerCase());
        }
        else {
            selectedServices.current.push({
                ServiceID: row.ServiceID,
                ServiceType: row.ServiceType,
                CustomerName: row.CustomerName,
                CustomerMobile: row.CustomerMobile,
                ServiceAddress: row.ServiceAddress,
                ProductModel: row.ProductModel,
                ProductName: row.ProductName,
                InvoiceNumber: row.InvoiceNumber
            })
        }
    }
    function search(data) {
        data.Skip = 0;
        selectedServices.current = [];
        const pContactDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        if (pContactDateFrom !== "") {
            data.ContactDateFrom = dateFilters.current.ContactDateFrom;
        }
        else {
            dateFilters.current.ContactDateFrom = null;
        }
        const pContactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (pContactDateTo !== "") {
            data.ContactDateTo = dateFilters.current.ContactDateTo;
        }
        else {
            dateFilters.current.ContactDateTo = null;
        }
        const pSendDateFrom = document.getElementsByName("SendDateFrom")[0].value;
        if (pSendDateFrom !== "") {
            data.SendDateFrom = dateFilters.current.SendDateFrom;
        }
        else {
            dateFilters.current.SendDateFrom = null;
        }
        const pSendDateTo = document.getElementsByName("SendDateTo")[0].value;
        if (pSendDateTo !== "") {
            data.SendDateTo = dateFilters.current.SendDateTo;
        }
        else {
            dateFilters.current.SendDateTo = null;
        }
        dispatch(getManageSendingStaffList(data));
    }
    function clearFilters() {
        frmFilters.current.reset();
        dateFilters.current = {};
        dispatch(getManageSendingStaffList({ Take: 10, Skip: 0 }));
    }
    function toExcel() {
        const url = "api/ManageSendingStaffAPI/GetManageSendingStaffList";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        exportToExcel("ManageSendingStaff", searchArgs, url, "post", tableCols);
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
        }
        const onSelect = (staff) => {
            if (staff) {
                setSendingInfo({ ...sendingInfo, StaffID: staff.ID, StaffName: staff.LastName, StaffMobile: staff.Mobile });
            }
        }
        setPopSelectStaff({
            show: true,
            onSelect: onSelect
        })
    }
    function submitSendStaff() {
        setSubmitError(null);
        if (selectedServices.current.length === 0) {
            setSubmitError("سرویسی انتخاب نشده است");
            return;
        }
        if ((sendingInfo.StaffID ?? 0) === 0) {
            setSubmitError("تکنسینی برای اعزام انتخاب نشده است");
            return;

        }
        if (!filterData.DistributionState || filterData.DistributionState === 'false') {
            setSubmitError("فیلتر جستجو باید روی مرحله توزیع باشد");
            return;
        }
        if (sendingInfo.SendSMSToStaff === undefined) {
            sendingInfo.SendSMSToStaff = true;
        }
        for (let i = 0; i < selectedServices.current.length; i++) {
            const s = selectedServices.current[i];
            Object.assign(s, sendingInfo);
        }
        const onSend = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "اعزام تکنسین");
                return;
            }
            if (res.Data) {
                if (res.Data.SMSMessage.length > 0) {
                    setErrorDialog(dispatch, "عملیت با موفقیت انجام شد. " + res.Data.SMSMessage, "اعزام تکنسین");
                }
                else {
                    setErrorDialog(dispatch, "success", "اعزام تکنسین");
                }
                dispatch(getManageSendingStaffList(filterData));
                selectedServices.current = [];
                inputSendDate.current.input.value = '';
                setSendingInfo({});
            }

        }
        sendStaff(selectedServices.current, onSend);
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "", colName: "", colType: "boolean", justInMobile: true, editable: true, onChange: onSelectRow },
        { colTitle: "نوع سرویس", colName: "PServiceType", justInMobile: true },
        { colTitle: "شماره سرویس", colName: "InvoiceNumber", justInMobile: true },
        { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate", justInMobile: true },
        {colTitle:"مارک محصول", colName:"HolderName", showCondition:()=>pgType === 0},
        { colTitle: (pgType === 1 ? "نام محصول" : "نوع محصول"), colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "کد مشتری", colName: "CustomerCode" },
        { colTitle: "نام مشتری", colName: "CustomerName" },
        { colTitle: "نشانی مشتری", colName: "ServiceAddress" },
        { colTitle: "تلفن مشتری", colName: "CustomerPhone" },
        { colTitle: "همراه مشتری", colName: "CustomerMobile" },
        { colTitle: "وضعیت سرویس", colName: "Status" },
        { colTitle: "توضیحات", colName: "Description" },
        { colTitle: "کد تکنسین", colName: "StaffCode" },
        { colTitle: "نام تکنسین", colName: "StaffName" },
        { colTitle: "تاریخ اعزام", colName: "PSendDate" },
        { colTitle: "ساعت اعزام", colName: "SendHour" },

    ]
    useEffect(() => {
        dispatch(getServiceStatusList());
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalSelectStaff popData={popSelectStaff} setPopSelectStaff={setPopSelectStaff} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faShareSquare} size="lg" />&nbsp;
                    مدیریت اعزام تکنسین
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom"
                                    value={filterData?.ContactDateFrom ? momentJalaali(filterData.ContactDateFrom.substring(0, 10)) : dateFilters.current.ContactDateFrom ? momentJalaali(dateFilters.current.ContactDateFrom) : null}
                                    onChange={val => dateFilters.current.ContactDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo"
                                    value={filterData?.ContactDateTo ? momentJalaali(filterData.ContactDateTo.substring(0, 10)) : dateFilters.current.ContactDateTo ? momentJalaali(dateFilters.current.ContactDateTo) : null}
                                    onChange={val => dateFilters.current.ContactDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>

                            <Col md={2} className="form-group">
                                <label>تاریخ اعزام از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="SendDateFrom"
                                    value={filterData?.SendDateFrom ? momentJalaali(filterData.SendDateFrom.substring(0, 10)) : dateFilters.current.SendDateFrom ? momentJalaali(dateFilters.current.SendDateFrom) : null}
                                    onChange={val => dateFilters.current.SendDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ اعزام تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="SendDateTo"
                                    value={filterData?.SendDateTo ? momentJalaali(filterData.SendDateTo.substring(0, 10)) : dateFilters.current.SendDateTo ? momentJalaali(dateFilters.current.SendDateTo) : null}
                                    onChange={val => dateFilters.current.SendDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group" >
                                <label>نوع سرویس: </label>
                                <select className="form-control" name="ServiceType" ref={register({})} defaultValue={filterData?.ServiceType ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="install">نصب</option>
                                    <option value="repair">تعمیر</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>توضیحات سرویس: </label>
                                <Form.Control name="Description" ref={register({})} defaultValue={filterData?.Description} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سرویس: </label>
                                <Form.Control type="number" name="InvoiceNumber" ref={register({})} defaultValue={filterData?.InvoiceNumber} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت بایگانی: </label>
                                <select className="form-control" ref={register({})} name="IsArchive">
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>بایگانی نشده</option>
                                    <option value={true}>بایگانی شده</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت سرویس: </label>
                                {serviceStatusList === "PENDING" &&
                                    <div className='form-control col-md-3'>
                                        <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                        <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری لیست وضعیت</span>
                                    </div>
                                }
                                {serviceStatusList && Array.isArray(serviceStatusList) &&
                                    <select className="form-control" name="StatusID" ref={register({})} defaultValue={filterData?.StatusID ?? ""}>
                                        <option value="">انتخاب وضعیت سرویس</option>
                                        {serviceStatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرحله سرویس: </label>
                                <select className="form-control" name="DistributionState" ref={register({})} defaultValue={filterData?.DistributionState ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={true}>مرحله توزیع</option>
                                    <option value={false}>سایر مراحل</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>سریال محصول: </label>
                                <Form.Control name="ProductSerial" ref={register({})} defaultValue={filterData?.ProductSerial ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>{(pgType === 1 ? "نام" : "نوع") + " محصول"}</label>
                                <Form.Control name="ProductName" ref={register({})} defaultValue={filterData?.ProductName} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مدل محصول: </label>
                                <Form.Control name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel} />
                            </Col>
                            {pgType === 0 &&
                                <Col md={2} className="form-group">
                                    <label>مارک محصول: </label>
                                    <Form.Control name="HolderName" ref={register({})} defaultValue={filterData?.HolderName} />
                                </Col>
                            }
                            <Col md={2} className="form-group">
                                <label>کد مشتری: </label>
                                <Form.Control name="CustomerCode" ref={register({})} defaultValue={filterData?.CustomerCode} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام مشتری: </label>
                                <Form.Control name="CustomerName" ref={register({})} defaultValue={filterData?.CustomerName} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تلفن مشتری: </label>
                                <Form.Control name="CustomerPhone" ref={register({})} defaultValue={filterData?.CustomerPhone} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>همراه مشتری: </label>
                                <Form.Control name="CustomerMobile" ref={register({})} defaultValue={filterData?.CustomerMobile} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نشانی مشتری: </label>
                                <Form.Control name="ServiceAddress" ref={register({})} defaultValue={filterData?.ServiceAddress} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام تکنسین: </label>
                                <Form.Control name="StaffName" ref={register({})} defaultValue={filterData?.StaffName} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کد تکنسین: </label>
                                <Form.Control name="StaffCode" ref={register({})} defaultValue={filterData?.StaffCode} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <select className="form-control" name="Take" ref={register({})} defaultValue={filterData?.Take ?? 10}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={10}>10 ردیف</option>
                                    <option value={20}>20 ردیف</option>
                                    <option value={50}>50 ردیف</option>
                                    <option value={100}>100 ردیف</option>
                                </select>
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="submit"><Search size={16} />&nbsp; جستـجـو&nbsp;</Button>
                    </form>
                    <div style={{ padding: 0, width: "100%", textAlign: "left" }}><FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" /></div>
                    <BihamtaTable columns={tableCols} style={{ whiteSpace: "nowrap" }} objectName="manageSendingStaffList" reducerName="service"
                        searchMethod={(data) => dispatch(getManageSendingStaffList(data))} filterData={filterData} hasPaging={true} className="mt-0" />
                    <Row className="rowBorder mt-2" style={{ textAlign: "right" }}>
                        <Col md={2} className="form-group">
                            <label>تکنسین اعزامی: </label>
                            <Form.Control value={sendingInfo.StaffName ?? ""} onKeyDown={showModalStaff} />
                            <Button className="btn-input-tiny" onClick={showModalStaff}><List size={20} /></Button>
                        </Col>
                        <Col md={2} className="form-group" style={{ maxWidth: "max-content" }}>
                            <label className="ellipsisLabel" title="تاریخ و ساعت اعزام">تاریخ و ساعت اعزام: </label>
                            <DatePicker isGregorian={false} timePicker={true} className="form-control" ref={inputSendDate} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm"
                                onChange={val => setSendingInfo({ ...sendingInfo, SendDate: val.local("en").format("YYYY-MM-DD HH:mm") })} />
                        </Col>
                        <Col md={5} style={{ display: "flex", alignItems: "flex-end", maxWidth: "max-content" }}>
                            <div className="rowBorder" style={{ padding: "10px" }}>
                                <div style={{ display: "inline-block" }}>
                                    <input type="checkbox" className="form-check-input" style={{ marginTop: "0px" }} onChange={e => setSendingInfo({ ...sendingInfo, ShowStaffInfoToCustomer: e.target.checked })} />&nbsp;
                                    <label style={{ color: "blue", fontSize: "12px" }}>نمایش شماره همراه تکنسین برای مشتری</label> &nbsp;
                                </div>
                                <div style={{ display: "inline-block" }}>
                                    <input type="checkbox" className="form-check-input" style={{ marginTop: "0px" }} onChange={e => setSendingInfo({ ...sendingInfo, SendSMSToStaff: e.target.checked })} defaultChecked={true} />&nbsp;
                                    <label style={{ color: "blue", fontSize: "12px" }}>ارسال پیامک به تکنسین</label>
                                </div>
                            </div>
                        </Col>
                        <Col md={3} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                            <Button variant="info" className="group-Btn" onClick={submitSendStaff}><CheckLg size={16} />&nbsp;ثبـت اعـزام</Button>
                        </Col>
                        {submitError &&
                            <Row style={{ margin: 0 }} className="mt-2">
                                <Alert variant="danger">
                                    <ExclamationTriangle size={18} />&nbsp;
                                    {submitError}
                                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setSubmitError(null)} style={{ float: "left" }} />
                                </Alert>
                            </Row>
                        }
                    </Row>
                </Card.Body>
            </Card >
        </div >
    )
}
export default ManageSendingStaffList;